import { getBrowserLang } from "./browser";
export const setDocumentLang = lang => {
  const browserLanguage = getBrowserLang();
  const docLang = lang !== null && lang !== void 0 ? lang : browserLanguage;
  if (docLang) {
    document.documentElement.setAttribute('lang', docLang);
  }
};
export const setDocumentTitle = title => document.title = title;